import { CompassVector } from '../../math/geometry/compassVector';
import { VisibilityVertex } from '../visibility/VisibilityVertex';
export class VisibilityVertexRectilinear extends VisibilityVertex {
    constructor(point) {
        super(point);
    }
    SetVertexEntry(entry) {
        if (this.VertexEntries == null) {
            this.VertexEntries = new Array(4);
        }
        this.VertexEntries[CompassVector.ToIndex(entry.Direction)] = entry;
    }
    RemoveVertexEntries() {
        this.VertexEntries = null;
    }
}
//# sourceMappingURL=VisibilityVertexRectiline.js.map